<template>
  <div class="tables">
    <a-modal
      centered
      v-model="visible2"
      title="审核不通过"
      @ok="handleOk2"
      :maskStyle="{ opacity: 0.1 }"
      cancelText="取消"
      okText="确定"
    >
      <span>原因</span>
      <a-textarea
        centered
        v-model="value"
        placeholder="请输入不通过原因"
        :auto-size="{ minRows: 3, maxRows: 5 }"
      />
    </a-modal>
    <a-modal
      v-model="visible"
      title="编辑"
      @ok="handleOk"
      :maskStyle="{ opacity: 0.1 }"
      cancelText="取消"
      okText="确定"
    >
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="姓名">
          <a-input v-model="form.userName" />
        </a-form-model-item>
        <a-form-model-item label="手机号码">
          <a-input v-model="form.phone" />
        </a-form-model-item>
        <a-form-model-item label="邀请码">
          <a-input v-model="form.recommendId" />
        </a-form-model-item>
        <a-form-model-item label="代理区域">
          <a-select v-model="form.shopId" placeholder="请选择">
            <a-select-option
              v-for="(item, index) in dropDown"
              :key="index"
              :value="item.objId"
            >
              {{ item.name }}
            </a-select-option>
            <!-- <a-select-option value="beijing"> Zone two </a-select-option> -->
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(item) => item.shopId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="pic" slot-scope="text">
        <img :src="text" alt="" />
      </template>
      <template slot="pictwo" slot-scope="text">
        <img :src="text" alt="" />
      </template>
      <template slot="settleStatus" slot-scope="text">
        <span v-if="text === 1401 || text === 1301">{{
          text === 1401 ? "审核成功" : "审核失败"
        }}</span>
        <span v-else>审核中</span>
      </template>
      <template slot="operate" slot-scope="text, operate">
        <a v-on:click.prevent="showModal(operate)">编辑</a>
        <a href="javascript:;" @click="getPast(operate)">通过</a>
        <a v-on:click.prevent="showModal2" @click="aaa(operate)">不通过</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  storeDistributorsList,
  storeDistributorsListUpdate,
  storeDistributorsListInfo,
  storeDistributorsListXiala,
  storeDistributorsListSettle,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "用户uid",
    dataIndex: "userUid",
    sorter: true,
    scopedSlots: { customRender: "userUid" },
  },
  {
    title: "姓名",
    dataIndex: "settledAdminName",
    sorter: true,
  },
  {
    title: "手机号",
    dataIndex: "phone",
    sorter: true,
  },
  {
    title: "邀请码",
    dataIndex: "recommendId",
    sorter: true,
    width: 150,
    scopedSlots: { customRender: "recommendId" },
  },
  {
    title: "身份证号",
    dataIndex: "dutyCardNumber",
    sorter: true,
    scopedSlots: { customRender: "dutyCardNumber" },
  },
  {
    title: "身份证正面",
    dataIndex: "dutyCardFront",
    sorter: true,
    key: "pic",
    scopedSlots: { customRender: "pic" },
  },
  {
    title: "身份证反面",
    dataIndex: "dutyCardReverse",
    sorter: true,
    scopedSlots: { customRender: "pic" },
  },
  {
    title: "代理门店",
    dataIndex: "name",
    sorter: true,
    width: 150,
  },
  {
    title: "审核状态",
    dataIndex: "settleStatus",
    sorter: true,
    scopedSlots: { customRender: "settleStatus" },
  },
  {
    title: "入驻时间",
    dataIndex: "createTime",
    sorter: true,
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      dropDown: "",
      id: "",
      objId: "",
      data: [],
      limit: 10,
      page: 1,
      value: null,
      loading: false,
      columns,
      visible: false,
      visible2: false,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        id: "",
        phone: "",
        userName: "",
        recommendId: "",
        shopId: "",
      },
    };
  },
  props: ["formInline"],
  mounted() {
    // 分页数据
    this.getStoreDistributorsList();
    // 获取分销商审核下拉框数据
    this.getDistributorsXiala();
  },
  methods: {
    // topage(routerpath, data) {
    //   this.$router.push(routerpath, data);
    // },
    // 获取不通过的id
    aaa(record) {
      console.log(record.objId);
      this.id = record.objId;
    },
    // 下拉框数据
    getDistributorsXiala() {
      storeDistributorsListXiala().then((res) => {
        this.dropDown = res.data;
        console.log(res);
      });
    },
    // 通过审核
    getPast(record) {
      console.log(record.objId);
      storeDistributorsListSettle({ id: record.objId, status: 1401 }).then(
        (res) => {
          if (res.code === "0000") {
            message.success(res.data);
            this.getStoreDistributorsList();
          }
          message.warning(res.info);
        }
      );
    },

    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      storeDistributorsList({ limit: 10, page: this.pagination.current }).then(
        (res) => {
          this.data = res.data;
          console.log(res);
          this.loading = false;
        }
      );
    },
    // 分页
    getStoreDistributorsList() {
      storeDistributorsList({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal(row) {
      this.form.id = row.objId;
      this.visible = true;
      // 编辑明细数据
      storeDistributorsListInfo(row.objId).then((res) => {
        this.form.userName = res.data.userName;
        this.form.phone = res.data.phone;
        this.form.recommendId = res.data.recommendId;
      });
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
      this.loading = true;
      storeDistributorsListUpdate(this.form).then((res) => {
        this.loading = false;
        message.success(res.data);
        this.getStoreDistributorsList();
      });
    },
    showModal2() {
      this.visible2 = true;
    },
    handleOk2(e) {
      // console.log(e);
      this.visible2 = false;
      console.log(this.value);
      // 审核不通过
      storeDistributorsListSettle({
        id: this.id,
        status: 1301,
        remark: this.value,
      }).then((res) => {
        if (res.code === "0000") {
          message.success(res.data);
          this.getStoreDistributorsList();
        }
        message.warning(res.info);
      });
    },
    query() {
      this.loading = true;
      storeDistributorsList(this.formInline).then((res) => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
  },
};
</script>
<style scoped>
.tables {
  height: 728px;
}
img {
  width: 64px;
  height: 42px;
}
</style>


// WEBPACK FOOTER //
// src/views/proxyAuditTwo/proxyAuditContentTwo.vue